// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%278%27 viewBox=%270 0 12 8%27%3E%3Cpath d=%27m1 1.5 5 5 5-5%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%271.8%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.language-select {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: inherit;
  font-weight: 700;
  line-height: 1;
}

.language-select__label {
  font-size: 0.82rem;
  line-height: 1;
}

.language-select select {
  min-width: 116px;
  border: 1px solid rgba(148, 163, 184, 0.55);
  border-radius: 8px;
  background: #ffffff;
  color: #0f172a;
  font: inherit;
  font-size: 0.86rem;
  font-weight: 700;
  padding: 7px 28px 7px 10px;
}

.language-select select:focus {
  outline: 2px solid rgba(37, 99, 235, 0.35);
  outline-offset: 2px;
}

.language-select--login {
  flex: 0 0 auto;
  height: 42px;
  min-height: 42px;
  max-height: 42px;
  padding: 0 5px 0 12px;
  box-sizing: border-box;
  border: 1px solid #dbe8ff;
  border-radius: 14px;
  background: #f8fbff;
  color: #0f172a;
}

.language-select--login select {
  min-width: 112px;
  height: 34px;
  padding-block: 5px;
  border-color: transparent;
  border-radius: 10px;
}

.language-select--header {
  flex: 0 0 auto;
  height: 36px;
  min-height: 36px;
  max-height: 36px;
  padding: 0 5px 0 11px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.15);
  color: #f8fafc;
}

.language-select--header select {
  appearance: none;
  min-width: 104px;
  height: 34px;
  min-height: 34px;
  max-height: 34px;
  padding: 4px 28px 4px 10px;
  border: 0;
  border-radius: 999px;
  color: #ffffff;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 9px center;
}

.language-select--header select option {
  color: #0f172a;
  background: #ffffff;
}

@media (max-width: 900px) {
  .header-right--catalog {
    flex-wrap: wrap;
  }

  .language-select--header {
    align-self: center;
  }
}

@media (max-width: 560px) {
  .language-select--login {
    width: 100%;
    justify-content: space-between;
    min-width: 0;
  }

  .language-select--login select {
    flex: 1 1 auto;
    min-width: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/LanguageSelect.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,oBAAoB;EACpB,cAAc;EACd,6BAA6B;EAC7B,yDAAuQ;EACvQ,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,WAAW;IACX,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":[".language-select {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  color: inherit;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.language-select__label {\n  font-size: 0.82rem;\n  line-height: 1;\n}\n\n.language-select select {\n  min-width: 116px;\n  border: 1px solid rgba(148, 163, 184, 0.55);\n  border-radius: 8px;\n  background: #ffffff;\n  color: #0f172a;\n  font: inherit;\n  font-size: 0.86rem;\n  font-weight: 700;\n  padding: 7px 28px 7px 10px;\n}\n\n.language-select select:focus {\n  outline: 2px solid rgba(37, 99, 235, 0.35);\n  outline-offset: 2px;\n}\n\n.language-select--login {\n  flex: 0 0 auto;\n  height: 42px;\n  min-height: 42px;\n  max-height: 42px;\n  padding: 0 5px 0 12px;\n  box-sizing: border-box;\n  border: 1px solid #dbe8ff;\n  border-radius: 14px;\n  background: #f8fbff;\n  color: #0f172a;\n}\n\n.language-select--login select {\n  min-width: 112px;\n  height: 34px;\n  padding-block: 5px;\n  border-color: transparent;\n  border-radius: 10px;\n}\n\n.language-select--header {\n  flex: 0 0 auto;\n  height: 36px;\n  min-height: 36px;\n  max-height: 36px;\n  padding: 0 5px 0 11px;\n  box-sizing: border-box;\n  border: 1px solid rgba(255, 255, 255, 0.24);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.15);\n  color: #f8fafc;\n}\n\n.language-select--header select {\n  appearance: none;\n  min-width: 104px;\n  height: 34px;\n  min-height: 34px;\n  max-height: 34px;\n  padding: 4px 28px 4px 10px;\n  border: 0;\n  border-radius: 999px;\n  color: #ffffff;\n  background-color: transparent;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='m1 1.5 5 5 5-5' fill='none' stroke='%23fff' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 9px center;\n}\n\n.language-select--header select option {\n  color: #0f172a;\n  background: #ffffff;\n}\n\n@media (max-width: 900px) {\n  .header-right--catalog {\n    flex-wrap: wrap;\n  }\n\n  .language-select--header {\n    align-self: center;\n  }\n}\n\n@media (max-width: 560px) {\n  .language-select--login {\n    width: 100%;\n    justify-content: space-between;\n    min-width: 0;\n  }\n\n  .language-select--login select {\n    flex: 1 1 auto;\n    min-width: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
